import { Injectable } from '@angular/core';
import { HelperService } from '../shared/services/helper.service';
import { HttpService } from '../shared/services/http.service';
import { environment } from 'src/environments/environment';
import { GiftCardNCRModel } from '../models/gifcardVirtual.model';

@Injectable()
export class CacService {
    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    
    constructor(private httpService: HttpService) { }
    
    public GetGiftCardBySecuence(params){
        this.URL = `${this.REQUEST_URL}/getGiftCardBySecuence`;
        return this.httpService.post<any>(this.URL, params);
    }

    public GetGiftCardByNumber(params){
        this.URL = `${this.REQUEST_URL}/getGiftCardByNumber`;
        return this.httpService.post<GiftCardNCRModel[]>(this.URL, params);
    }

    public GetGiftCardByUseType(params){
        this.URL = `${this.REQUEST_URL}/getGiftCardByUseType`;
        return this.httpService.post<GiftCardNCRModel[]>(this.URL, params);
    }
}